"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResolveBrowser = exports.FormatBrowserCapabilities = void 0;
var ts_pattern_1 = require("ts-pattern");
var __1 = require("..");
var SeleniumBrowserValidators_1 = require("../validators/SeleniumBrowserValidators");
var FormatBrowserCapabilities = function (browserName, version) {
    var resolvedBrowserName = ts_pattern_1.match(browserName)
        .with(__1.SupportedBrowsers.ChromeMobile, function () { return __1.SupportedBrowsers.Chrome.toString(); })
        .otherwise(function () { return browserName.toString(); });
    var defaultBrowserVersion = __1.SeleniumBrowsers[browserName].default;
    var resolvedVersion = version || defaultBrowserVersion;
    // Check that the given version is supported, throw if not.
    if (!!resolvedVersion) {
        SeleniumBrowserValidators_1.SeleniumBrowserValidateOrThrow(browserName, resolvedVersion);
        // Chrome Mobile is actually a subset of chrome so the image name needs to be mapped back to "chrome: mobile-version"
        resolvedVersion = ts_pattern_1.match(browserName)
            .with(__1.SupportedBrowsers.ChromeMobile, function () { return "mobile-" + resolvedVersion.replace("mobile-", ""); })
            .otherwise(function () { return resolvedVersion; });
    }
    return { browserName: resolvedBrowserName, browserVersion: resolvedVersion };
};
exports.FormatBrowserCapabilities = FormatBrowserCapabilities;
var ResolveBrowser = function (browserName, version) {
    var resolvedBrowserName = ts_pattern_1.match(browserName)
        .with(__1.SupportedBrowsers.ChromeMobile, function () { return __1.SupportedBrowsers.Chrome.toString(); })
        .otherwise(function () { return browserName.toString(); });
    var defaultBrowserVersion = __1.SeleniumBrowsers[browserName].default;
    var resolvedVersion = version || defaultBrowserVersion;
    // Check that the given version is supported, throw if not.
    if (!!resolvedVersion) {
        if (!SeleniumBrowserValidators_1.SeleniumBrowserValidate(browserName, resolvedVersion)) {
            resolvedVersion = defaultBrowserVersion;
        }
        // Chrome Mobile is actually a subset of chrome so the image name needs to be mapped back to "chrome: mobile-version"
        resolvedVersion = ts_pattern_1.match(browserName)
            .with(__1.SupportedBrowsers.ChromeMobile, function () { return "mobile-" + resolvedVersion.replace("mobile-", ""); })
            .otherwise(function () { return resolvedVersion; });
    }
    return { browserName: resolvedBrowserName, browserVersion: resolvedVersion };
};
exports.ResolveBrowser = ResolveBrowser;
